// extracted by mini-css-extract-plugin
export default {"textContainer":"InfoGraphics_textContainer__DuS64","heading":"InfoGraphics_heading__t1e3B"};